/** Deux codes (promo, carte cadeau) désignent le même : comparés sans espaces ni casse, jamais vides. */
export const sameCode = (a: string | undefined, b: string | undefined): boolean =>
  !!a && !!b && a.trim().toUpperCase() === b.trim().toUpperCase();
